import { Button, ButtonGroup, Field, NumericInput, TextOutput } from 'Components/Core';
import { NamePrefixModifier, withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { FieldSet, ListFieldSection } from 'Components/Layout';
import { WorksheetBalanceFieldSet } from 'Components/Worksheets/Core';
import { IWorksheetComponent } from 'Components/Worksheets/Core/types';
import { actions } from 'Data/ReduxViewModels/WorksheetEditor';
import deepEquals from 'Lib/Object/deepEquals';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

let WholePortionAnnexBPreparationSingleTraySection: React.FC<IWorksheetComponent> = ({
  createWorksheetSelector,
  prefixName,
}) => {
  const dispatch = useDispatch();

  const lightweightAggregate: boolean = useSelector(
    createWorksheetSelector!('data.Preparation.LightweightAggregate', false)
  );

  const trays = useSelector(
    createWorksheetSelector!('Masses.MassMeasurement.WetMassMeasurements'),
    deepEquals
  ) as any[];

  const updateTrays = (value: any[]) => {
    dispatch(
      actions.setValue({
        name: prefixName!('Masses.MassMeasurement.WetMassMeasurements'),
        value: value,
        sync: true,
      })
    );
  };

  return (
    <>
      <NamePrefixModifier appendNamePrefix="Masses.MassMeasurement">
        <ListFieldSection>
          <WorksheetBalanceFieldSet name="Equipment.Balance" />
          <Field input={<NumericInput />} name="BulkDensity" visible={lightweightAggregate} />
          <Field input={<NumericInput />} name="WetMassMeasurements[0].TareMass" />
          <FieldSet>
            <Field input={<NumericInput />} name="WetMassMeasurements[0].TareAndWetMass" />
            <ButtonGroup>
              <Button onClick={() => updateTrays([...trays, {}])}>Add Tray</Button>
            </ButtonGroup>
          </FieldSet>
          <Field input={<TextOutput />} name="WetMass" />
          <Field input={<TextOutput />} name="Volume" visible={lightweightAggregate} />
        </ListFieldSection>
      </NamePrefixModifier>
    </>
  );
};

WholePortionAnnexBPreparationSingleTraySection = withInjectedProps(WholePortionAnnexBPreparationSingleTraySection);

export { WholePortionAnnexBPreparationSingleTraySection };
export default WholePortionAnnexBPreparationSingleTraySection;
